import React from "react";
import "./Bill.css";

const Bill = ({ bill, onClick }) => {
  const previewLength = 100;
  const preview =
    bill.summary.length > previewLength
      ? `${bill.summary.substring(0, previewLength)}…`
      : bill.summary;

  return (
    <article className="box" onClick={onClick} role="button" tabIndex={0} onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick();
      }
    }}>
      <h2>{bill.title}</h2>
      <p>{preview}</p>
      <div className="meta">
        {bill.date} | {bill.type}
      </div>
    </article>
  );
};

export default Bill;
